const options = {
  5: "bg-yellow-400/5",
  10: "bg-yellow-400/10",
  25: "bg-yellow-400/25",
  50: "bg-yellow-400/50",
  75: "bg-yellow-400/75",
  90: "bg-yellow-400/90",
  100: "bg-yellow-400",
};

const from = {
  5: "from-yellow-400/5",
  10: "from-yellow-400/10",
  25: "from-yellow-400/25",
  50: "from-yellow-400/50",
  75: "from-yellow-400/75",
  90: "from-yellow-400/90",
  100: "from-yellow-400",
};

export default function getBackgroundYellow400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
